// extracted by mini-css-extract-plugin
module.exports = {"splitLayout":"SplitLayout_splitLayout__jX8fY","shimmer":"SplitLayout_shimmer__0vPki"};